import { Component } from "react"

/* Components */
import { GameFilter, GameList, Layout } from "../../components"

/* Helpers */
import { utils } from "../../helpers"

/* REST API */
import { games } from "../../api/Electron"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

/* Moment Settings */
moment.locale("ru")


/* PAGE SIZE OF THE LIST */
const SIZE = 20


/* THE COLUMNS OF THE LIST — THE NUMBER AND THE DATE OF A ROUND BELONG TO THE LIST ITSELF */
const COLUMNS = () => [
    {
        key: "player",
        text: t("widget.player"),
        flex: 1.4,
        render: (item) => (
            <div className="gl--player">
                <h4>{item.gamePlayer ? utils.checkValue(item.gamePlayer.firstName, "—") : "—"}</h4>
                <p>
                    {item.player}
                    {item.gamePlayer && parseInt(item.gamePlayer.isTester) === 1 && <span className="gl--tester">{t("player.isTester")}</span>}
                </p>
            </div>
        ),
    },
    { key: "operator", text: t("widget.operator"), render: (item) => item.gamePlayer && item.gamePlayer.operator ? <div className="gl--badge amber">{item.gamePlayer.operator}</div> : null },
    { key: "status", text: t("widget.status"), type: "status", flex: 1.2 },
]

/* Widget ElectronGames — the games list of any electron game */
class ElectronGames extends Component {

    constructor() {
        super()

        const date = utils.getDate()

        this.state = {
            data: [],
            status: "loading",
            page: 1,
            count: 0,
            number: "",
            playerID: "",
            startDate: date.startDate,
            endDate: date.endDate,

            operators: [],
        }
    }

    componentDidMount = () => {
        this.setState({ operators: this.props.operators || [] }, () => this.load(1))
    }

    /* Reload Action — the page asks for it when the card of a round closes */
    reloadGames = () => {
        this.load(1, true)
    }

    /* Load Games list — the scope comes from the token, the operators below only narrow it down */
    load = (page = 1, reload = false) => {

        /* Fields */
        const { number, playerID, startDate, endDate, operators } = this.state
        const start = moment(startDate).format("YYYY-MM-DD HH:mm:ss")
        const end = moment(endDate).format("YYYY-MM-DD HH:mm:ss")
        const { uid, game } = this.props

        /* Check Params */
        if (!uid || !game) {
            this.setState({ status: "error", data: [] })
            return
        }

        /* Save Page */
        this.setState({ page })

        /* Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* START REST API */
        games(game.key, { uid, operators: utils.arrayID(operators), page, number, playerID, start, end }).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data.list, count: response.data.count })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [], count: 0 })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [], count: 0 })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0 })
        })

    }

    /* Set Number Action */
    setNumber = (number) => {
        if (number === "") {
            this.setState({ number }, () => this.load(1))
        }
        else {
            this.setState({ number })
        }
    }

    /* Set Player Action */
    setPlayer = (playerID) => {
        if (playerID === "") {
            this.setState({ playerID }, () => this.load(1))
        }
        else {
            this.setState({ playerID })
        }
    }





    render = () => {

        /* Fields */
        const { status, data, page, count, number, playerID, startDate, endDate, operators } = this.state
        const { openGame } = this.props


        return (
            <div className="electron--game-list">

                <GameFilter
                    status={status}
                    number={number}
                    player={playerID}
                    operators={operators}
                    start={startDate}
                    end={endDate}
                    onNumber={(number) => this.setNumber(number)}
                    onPlayer={(playerID) => this.setPlayer(playerID)}
                    onFilter={(patch) => this.setState(patch, () => this.load(1, true))}
                    submit={() => this.load(1, true)}
                    reload={() => this.load(1, true)}
                />

                {/* The bar above stays in place while the rounds are being read */}
                {status === "ok" &&
                    <GameList
                        columns={COLUMNS()}
                        data={data}
                        page={page}
                        size={SIZE}
                        count={count}
                        onOpen={(item) => openGame(item.id, item.number)}
                        onPage={(value) => this.load(value, true)}
                    />
                }

                {status !== "ok" && <Layout status={status} reload={() => this.load(1, true)} inner />}

            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        operators: state.operators,
        language: state.language,
    }
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(ElectronGames)
